import React, { Component } from 'react';

import Button from '../../UI/Button';

import { Modal } from 'antd';

class ConfirmModal extends Component {
  render() {
    return (
      <Modal
        visible={this.props.open}
        title={null}
        footer={null}
        closable={false}
        width={this.props.width || '350px'}
      >
        <p style={{fontSize:'16px', textAlign: 'center', padding: '30px 10px 30px 10px'}}>{this.props.text}</p>
        <p style={{textAlign: 'center', marginBottom: '5px'}}>
          <Button style={{ marginRight: '20px'}} key="back" size="large" onClick={this.props.onClose}>Annuleren</Button>
          <Button
            key="submit"
            type="primary"
            size="large"
            onClick={this.props.onConfirm}
          >
            Bevestigen
          </Button>
        </p>
      </Modal>
    );
  }
}

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/components/Orders/Modals/ConfirmModal.js